import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../utils/axiosInstance"; // Assuming this path is correct

const Login = () => {
  // 1. State for form inputs
  const [formData, setFormData] = useState({
    Name: "",
    Password: "",
  });

  // 2. State for UI feedback
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    // Clear error message when the user starts typing
    setError(null);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // ... (validation code remains the same)
    if (!formData.Name || !formData.Password) {
      setError("Please enter both Name and Password.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axiosInstance.post("admin/login", {
        Name: formData.Name,
        Password: formData.Password,
      });

      // Assuming your backend returns a token and a user object
      const { token, user } = response.data;

      // 3. SUCCESSFUL LOGIN LOGIC:

      // 👇👇 THIS IS THE FIX 👇👇
      // 1. Create the data object expected by token.js
      const userDataToStore = {
        token: token,
        user: user,
      };

      // 2. Stringify and store the object
      localStorage.setItem("userData", JSON.stringify(userDataToStore));

      // Redirect to the dashboard or home page
      navigate("/dashboard");
    } catch (err) {
      // ... (error handling code remains the same)
      const errorMessage =
        err.response?.data?.message ||
        "Login failed. Please check your credentials.";
      setError(errorMessage);
      console.error("Login Error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-2xl overflow-hidden">
        <div className="p-8">
          <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-2">
            Welcome Back!
          </h2>
          <p className="text-center text-sm text-gray-600 mb-8">
            Sign in to access your dashboard.
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Email/Username Field */}
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Name
              </label>
              <input
                id="email"
                name="Name"
                type="text"
                required
                value={formData.Name}
                onChange={handleChange}
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition duration-150"
                placeholder="you@example.com"
                autoComplete="Name"
              />
            </div>

            {/* Password Field */}
            <div>
              <label
                htmlFor="Password"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Password
              </label>
              <input
                id="Password"
                name="Password"
                type="Password"
                required
                value={formData.Password}
                onChange={handleChange}
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition duration-150"
                placeholder="••••••••"
                autoComplete="current-Password"
              />
            </div>

            {/* Error Display */}
            {error && (
              <p className="text-sm text-red-600 font-medium text-center">
                {error}
              </p>
            )}

            {/* Submit Button */}
            <div>
              <button
                type="submit"
                disabled={isLoading}
                className="w-full flex justify-center py-2 px-4 border border-border-blue rounded-lg shadow-sm text-lg font-medium text-black bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? (
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                ) : (
                  "Sign In"
                )}
              </button>
            </div>
          </form>

          {/* Optional: Forgot Password/Registration Link */}
          <div className="mt-6 text-center">
            <Link
              to="/forgot-Password"
              className="text-sm font-medium text-blue-600 hover:text-blue-500"
            >
              Forgot your Password?
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
